import { tjenestePath, PARAM_RETUR_URL, PARAM_RETUR_URL_TEKST } from '@src/types/url';

import { PageRoutes } from '../types/types';

import { getAppUrl } from '@helsenorge/framework-utils/url';
import { HNeventShowAppInvitation } from '@helsenorge/framework-utils/web-component/events';

const getWindowOrigin = (): string => window.location.origin || new URL(window.location.href).origin;

export const removeReturnUrlParams = (url: string): string => {
  const cleanedUrl = new URL(url, getWindowOrigin());

  for (const parameterName of Array.from(cleanedUrl.searchParams.keys())) {
    const lowerCaseParameterName = parameterName.toLowerCase();
    if (lowerCaseParameterName === PARAM_RETUR_URL || lowerCaseParameterName === PARAM_RETUR_URL_TEKST) {
      cleanedUrl.searchParams.delete(parameterName);
    }
  }

  const source = cleanedUrl.searchParams.get('Source');
  if (source) {
    cleanedUrl.searchParams.set('Source', removeReturnUrlParams(source));
  }

  return cleanedUrl.pathname + cleanedUrl.search + cleanedUrl.hash;
};

const getAbsoluteSourceUrl = (url: string): string => {
  const parsedUrl = new URL(url, getWindowOrigin());
  const sourceUrl = parsedUrl.pathname === '/auth/signin' ? parsedUrl.searchParams.get('Source') || window.location.href : url;
  const cleanedUrl = new URL(removeReturnUrlParams(sourceUrl), getWindowOrigin());
  return cleanedUrl.href;
};

const getLoginUrl = (sourceUrl: string): string => `/auth/signin?Source=${encodeURIComponent(getAbsoluteSourceUrl(sourceUrl))}`;

export const getUrlToReturnToAfterLogin = (pathname: string, verktoyId: string): string => {
  if (!pathname) {
    return '';
  }
  const cleanedUrl = new URL(removeReturnUrlParams(window.location.href), getWindowOrigin());
  if (pathname === PageRoutes.finnVerktoy) {
    cleanedUrl.pathname = `${PageRoutes.finnVerktoy}/${verktoyId}`;
  } else if (pathname.includes(PageRoutes.finnVerktoy)) {
    const cleanedUrlWithoutVerktoyId = cleanedUrl.pathname.split('/').slice(0, -1).join('/');
    cleanedUrl.pathname = `${cleanedUrlWithoutVerktoyId}/${verktoyId}`;
  }

  return getLoginUrl(cleanedUrl.href);
};

const handleLogin = (returnUrl?: string): void => {
  window.history.replaceState(window.history.state, '', getLoginUrl(returnUrl || window.location.href));
  window.location.reload();
};

export const useLogin = (): {
  login: (ref?: React.MutableRefObject<HTMLButtonElement | HTMLAnchorElement | null>, returnUrl?: string) => void;
} => {
  const appUrl = getAppUrl();

  const login = (ref?: React.MutableRefObject<HTMLButtonElement | HTMLAnchorElement | null>, returnUrl?: string): void => {
    if (appUrl) {
      HNeventShowAppInvitation(
        () => {
          const fullAppUrl = appUrl + tjenestePath;
          window.location.href = fullAppUrl;
        },
        () => {
          handleLogin(returnUrl);
        },
        () => {
          ref?.current?.focus();
        }
      );
    } else {
      handleLogin(returnUrl);
    }
  };
  return { login };
};
